import type { ReactElement } from 'react';

import { Tooltip } from '@base-ui/react';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import { useNavigationContext } from './Navigation.context';
import { tooltipStyle } from './Navigation.css';

type Props = {
  children: ReactElement;
  tooltip: string;
};

export const NavigationTooltip = ({ children, tooltip }: Props) => {
  const { isCollapsed } = useNavigationContext();
  const isMobile = useMediaQuery(breakpoints.small);

  const showTooltip = isCollapsed && !isMobile;

  return (
    <Tooltip.Root disabled={!showTooltip} disableHoverablePopup>
      <Tooltip.Trigger render={children} />

      <Tooltip.Portal>
        <Tooltip.Positioner side="right" sideOffset={8}>
          <Tooltip.Popup className={tooltipStyle}>{tooltip}</Tooltip.Popup>
        </Tooltip.Positioner>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};
